import React, {useState} from 'react'
import PageLayout from '../../components/layout/PageLayout'
import useQueryTraderMapVolumes from '../../hooks/api/tradermap/useQueryTraderMapVolumes'
import useQueryTraderMapProjects from '../../hooks/api/tradermap_project/useQueryTraderMapProjects'
import WizImage from '../../components/image/WizImage'
import Text from '../../components/text/Text'

interface IProps {
    className?: string
}

export function TradermapVolume({className}: IProps) {
    const [symbol, setSymbol] = useState('')
    const {data: project} = useQueryTraderMapProjects(false)

    return (
        <PageLayout title={'Trader Map Volumes'} className="">
            <div className="flex items-center gap-x-2">
                {project?.map(item => {
                    return (
                        <div
                            key={item?.id}
                            onClick={() => {
                                setSymbol(item?.symbol)
                            }}
                            className={`border flex items-center gap-x-1 rounded-[5px] py-[10px] px-4 cursor-pointer ${
                                symbol === item?.symbol
                                    ? 'bg-primary border-primary '
                                    : 'border-line02 hover:border-primary bg-white'
                            }`}>
                            <WizImage src={item?.symbol_image} className="w-7 h-7 rounded-full" />
                            <Text className={`${symbol === item?.symbol ? 'text-white' : 'text-font01'}`}>
                                {item?.symbol}
                            </Text>
                        </div>
                    )
                })}
            </div>
        </PageLayout>
    )
}
